import { LOCALE_NAMES } from '@zt/i18n';

/** Mağazanın dilleri (F7-14): varsayılan pazarın dili önce, sonra diğer pazar dilleri (tekil). */
export function storeLanguages(
  store:
    { defaultMarketId?: string | null; markets: Array<{ id: string; locale: string }> } | null | undefined,
): string[] {
  if (!store) return ['tr'];
  const def = store.markets.find((m) => m.id === store.defaultMarketId) ?? store.markets[0];
  const out = [...new Set([def?.locale ?? 'tr', ...store.markets.map((m) => m.locale)])];
  return out.length ? out : ['tr'];
}

/** Dilin kendi dilindeki adı (Türkçe, English, Deutsch, العربية). */
export const languageName = (l: string) => LOCALE_NAMES[l as keyof typeof LOCALE_NAMES] ?? l;
